import { Commands } from "../../../vendor_core/core/src/commands/CommandEnum";
import CommandManager from "../../../vendor_core/core/src/commands/CommandManager";
import BetModel from '../../../vendor_core/core/src/model/BetModel';
import BuyFeatureModel from '../../../vendor_core/core/src/model/BuyFeatureModel';
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import VendorModel from "../../../vendor_core/src/model/VendorModel";
import VendorFinishState from "../../../vendor_core/src/states/VendorFinishState";
import CoinModel from '../../model/CoinModel';
import DoubleChanceModel from '../../model/DoubleChanceModel';
import { getScatterBoostCost } from '../ui/commands/TRWGameCommands';

export default class TRWFinishState extends VendorFinishState {
    public async enter(): Promise<any> {
        super.enter();
        CoinModel.changeState();
        if(VendorModel.freeGames == null || VendorModel.freeGames == undefined) {
            CommandManager.execute(Commands.UPDATE_WIN, {"win" : SpinModel.accumulatedWin});
        }

    }

    getBet(): number {
        let result = BetModel.totalBet;
        if (BuyFeatureModel.isInBuyFeatureFreeSpins) {
            result = BuyFeatureModel.getTotalBet();
        } else if (DoubleChanceModel.isActivated) {
            result = getScatterBoostCost();
        }

        return result
    }
}
